import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import InputText from '@/components/ui/InputText.vue'
import { message } from '@/plugins/message'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPassword',
  props: {
  required: { type: Boolean, default: false },
    modelValue: { type: String, default: '' },
    label: { type: String, default: 'パスワード' }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', val: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line func-call-spacing


const text = computed({
  get: () => props.modelValue,
  set: (val: string) => (emit('update:modelValue', val))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputText, _mergeProps({
    modelValue: _unref(text),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : null))
  }, _ctx.$attrs, {
    type: "password",
    pattern: "^[!-~]{8,}$",
    "invalid-pattern-message": _unref(message)('validation.invalidPasswordPattern'),
    label: __props.label,
    required: __props.required
  }), null, 16, ["modelValue", "invalid-pattern-message", "label", "required"]))
}
}

})